import React, { ChangeEvent, memo, useCallback, useState } from 'react';
import { Container, Label } from './style';
import { Input as InputBase } from '@chakra-ui/core';
import { IPaginationParams } from 'src/models/interfaces/pagination';
import InputMask from 'react-input-mask';
import Toast from '../Toast';

interface IProps {
  field?: string;
  paginationParams: IPaginationParams;
  onChange: (params: { page: number }) => void;
  label: string;
  placeholder?: string;
  width?: string;
  type?: string;
}

const reg = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/;

const SearchMaskField = memo(({ field = 'term', paginationParams, onChange, label, width, type, ...props }: IProps) => {
  const [searchTerm, setSearchTerm] = useState(paginationParams.term ?? '');
  const [full, setFull] = useState(false);
  const toast = Toast();

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value ?? '';

    if (value === searchTerm) return;

    setSearchTerm(value);

    switch (type) {
      case 'date':
        if (full && value === '__/__/____') {
          onChange({ [field]: '', page: 0 });
          setFull(false);
          return;
        }

        if (!/\d\d\/\d\d\/\d\d\d\d/.test(value)) return;

        if (!reg.test(value)) {
          toast.error('Data Inválida.');
          return;
        }

        onChange({ [field]: value, page: 0 });
        setFull(true);
        break;
    }
  }, [onChange, full, field, toast, type]);

  const handleEnter = useCallback(() => {

  }, []);

  return (
    <Container style={{ width: width }}>
      <Label>{label}</Label>
      <InputMask mask="99/99/9999" onChange={handleChange} value={searchTerm} alwaysShowMask={true}>
        {() =>
          <InputBase
            {...props}
            color="#333 !important"
            borderColor='#01509C'
            borderRadius='6px'
            height='36px'
            fontSize={14}
            onKeyDown={handleEnter}
          />
        }
      </InputMask>
    </Container>
  );
});

export default SearchMaskField;
